import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {Divider } from '@mui/material';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import FilerListTable from './components/Sidebar/components/FilerListTable';

const FilerListing = (): JSX.Element => {

  document.title = 'OCPF - Filer Listings';

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Filer List
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
           <FilerListTable isFullTable={true}></FilerListTable>
        </Grid>
      </Container>
    </Main>
  );
};

export default FilerListing;